export default __webpack_public_path__ + "static/PT-wstETH-5bc7f18ba63fb77c9434396f2ff42192.svg";